import React from 'react';

interface OliveBranchProps {
  width?: number;
  className?: string;
  color?: string;
  ariaLabel?: string;
}

/**
 * Garden House — olive sprig ornament. Used as section divider, letter
 * close, and small punctuation. Renders as a single tapered branch with
 * paired leaves; uses currentColor by default so it inherits oxblood
 * (or graphite, or whatever) from its container.
 */
export default function OliveBranch({
  width = 80,
  className,
  color,
  ariaLabel,
}: OliveBranchProps) {
  const aspect = 80 / 28;
  const height = width / aspect;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 28"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      role={ariaLabel ? 'img' : 'presentation'}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
      className={className}
      style={color ? { color } : undefined}
    >
      <path
        d="M4 14 C 28 14, 56 14, 76 14"
        stroke="currentColor"
        strokeWidth="0.7"
        strokeLinecap="round"
      />
      <g fill="currentColor">
        <ellipse cx="14" cy="9"  rx="4.6" ry="1.7" transform="rotate(-25 14 9)" />
        <ellipse cx="14" cy="19" rx="4.6" ry="1.7" transform="rotate(25 14 19)" />
        <ellipse cx="26" cy="9"  rx="4.4" ry="1.6" transform="rotate(-25 26 9)" />
        <ellipse cx="26" cy="19" rx="4.4" ry="1.6" transform="rotate(25 26 19)" />
        <ellipse cx="38" cy="10" rx="4"   ry="1.5" transform="rotate(-25 38 10)" />
        <ellipse cx="38" cy="18" rx="4"   ry="1.5" transform="rotate(25 38 18)" />
        <ellipse cx="50" cy="10" rx="3.4" ry="1.4" transform="rotate(-25 50 10)" />
        <ellipse cx="50" cy="18" rx="3.4" ry="1.4" transform="rotate(25 50 18)" />
        <ellipse cx="61" cy="11" rx="2.8" ry="1.2" transform="rotate(-25 61 11)" />
        <ellipse cx="61" cy="17" rx="2.8" ry="1.2" transform="rotate(25 61 17)" />
        <ellipse cx="71" cy="13" rx="2.4" ry="1.1" transform="rotate(-12 71 13)" />
      </g>
    </svg>
  );
}
